import React from "react";
import { Tooltip as AntTooltip } from "antd";
import "./Tooltip.less";

export const Tooltip = (props) => <AntTooltip overlayClassName="tailormed-tooltip" {...props} />;
